import { createContext } from "react";

import { Message } from "./Types";

export const ThemeModeContext = createContext({
  toggleThemeMode: () => {},
});

export const SnackbarContext = createContext({
  open: (_: Message) => {},
  close: () => {},
});

// for custom theme
export const ClientContext = createContext({
  set: (_: string) => {},
});
